var map = {
	"./black/hujiao2.png": "VT2r",
	"./blue/hujiao2.png": "DEbv",
	"./white/hujiao2.png": "T8F/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pSz+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/hujiao2\.png$
// module id = pSz+
// module chunks = 24